var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forRefund"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("申请退款时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.refundApplyTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6eb1f2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/completeRecords/details/forRefund.vue
// module id = Hgrd
// module chunks = 1